// @TODO: переписать логику работы звезд и стили на react и вынести в lt/components
import React, { useState } from 'react';
import type { FieldProps } from 'formik';
import classNames from 'classnames';
import styled from 'styled-components';

type Props = {
  label: string;
} & FieldProps;

const Wrapper = styled.li`
  cursor: pointer;
`;

export const RatingSelector = ({ label, field }: Props) => {
  const [selectedClassName, setSelectedClassName] = useState('selected');
  const isActive = (value: string) => {
    if (field.value) {
      return parseInt(value, 10) <= parseInt(field.value, 10);
    }
    return false;
  };
  const isSelected = (value: string) => field.value === value;

  const getName = () => field.name;

  return (
    <Wrapper>
      <div className="rating_title">{label}</div>
      <div className="rating_stars">
        <ul
          onMouseLeave={() => {
            setSelectedClassName('selected');
          }}
          onMouseEnter={() => {
            setSelectedClassName('_selected');
          }}
          className="stars"
        >
          <li
            className={classNames({
              active: isActive('1'),
              [selectedClassName]: isSelected('1'),
            })}
            data-title="очень плохо"
          >
            <label>
              <i className="lt-icon-star" />
              <input
                onChange={field.onChange}
                className="rating"
                type="radio"
                value="1"
                name={getName()}
              />
            </label>
          </li>
          <li
            className={classNames({
              active: isActive('2'),
              [selectedClassName]: isSelected('2'),
            })}
            data-title="плохо"
          >
            <label>
              <i className="lt-icon-star" />
              <input
                onChange={field.onChange}
                className="rating"
                type="radio"
                value="2"
                name={getName()}
              />
            </label>
          </li>
          <li
            className={classNames({
              active: isActive('3'),
              [selectedClassName]: isSelected('3'),
            })}
            data-title="средне"
          >
            <label>
              <i className="lt-icon-star" />
              <input
                onChange={field.onChange}
                className="rating"
                type="radio"
                value="3"
                name={getName()}
              />
            </label>
          </li>
          <li
            className={classNames({
              active: isActive('4'),
              [selectedClassName]: isSelected('4'),
            })}
            data-title="хорошо"
          >
            <label>
              <i className="lt-icon-star" />
              <input
                onChange={field.onChange}
                className="rating"
                type="radio"
                value="4"
                name={getName()}
              />
            </label>
          </li>
          <li
            className={classNames({
              active: isActive('5'),
              [selectedClassName]: isSelected('5'),
            })}
            data-title="прекрасно"
          >
            <label>
              <i className="lt-icon-star" />
              <input
                onChange={field.onChange}
                className="rating"
                type="radio"
                value="5"
                name={getName()}
              />
            </label>
          </li>
        </ul>
      </div>
    </Wrapper>
  );
};
